module.exports = __webpack_public_path__ + "img/iadministration.ceb6b8fc.jpg";